import { useCallback, useMemo, useState } from "react"

export const useWorkingQueue = () => {
  const [workingQueue, setWorkingQueue] = useState<string[]>([])

  const isBusy = useMemo(() => !!workingQueue.length, [workingQueue])

  const addToQueue = useCallback((key: string) => {
    if (key) {
      const newQ = [...workingQueue]
      newQ.push(key)
      setWorkingQueue(newQ)
    }
  }, [workingQueue])

  const removeFromQueue = useCallback((key: string) => {
    const newQ = [...workingQueue]
    const idx = newQ.indexOf(key)
    if (idx > -1) newQ.splice(idx, 1)
    setWorkingQueue(newQ)
  }, [workingQueue])

  return {
    isBusy,
    addToQueue,
    removeFromQueue
  }
}
